import { ActionType, BaseAction, HttpState } from '../../util/model';

interface State {
    saveConfig: HttpState;
}
const intitialState: State = {
    saveConfig: HttpState.Success,
}
export const httpReducer = (state: State = intitialState, action: BaseAction): State => {
    if(action.type === ActionType.REQUEST_USER_CONFIG_STATE) {
        return {
            ...state,
            saveConfig: action.payload
        }
    }
    return state;
}
